/* eslint-disable @typescript-eslint/naming-convention */
const sharedRoutes = {
  stopImpersonating: "/a/sessions/stop_impersonating",
  logout: "/logout",

  external: {
    support: "https://support.fullscript.com/",
    termsOfService: "https://fullscript.com/terms-of-service",
    privacyPolicy: "https://fullscript.com/privacy",
    accessibility: "https://fullscript.com/accessibility",
    californiaPrivacy: "https://fullscript.com/ccpa",
    autoshipHandout: "https://fs-marketing-files.s3.amazonaws.com/handouts/autoship-education.pdf",
    shippingPolicyWholesale:
      "https://support.fullscript.com/hc/en-us/articles/360047665712-Wholesale-shipping-policy",
    shippingPolicyRetail:
      "https://support.fullscript.com/hc/en-us/articles/360020978272-Patient-shipping-policy",
    refundPolicy: "https://support.fullscript.com/hc/en-us/articles/360020956252-Refunds-returns",
    protocolsMarketingPage:
      "https://support.fullscript.com/hc/en-us/articles/360046986612-Sharing-wellness-protocols-with-patients",
    profitDispensariesSupportPage:
      "https://support.fullscript.com/hc/en-us/articles/360022163832-Profit-dispensaries",
    wellevateMigrationSupport:
      "https://support.fullscript.com/hc/en-us/sections/13558530393115-Wellevate-migration",
    dispensaryAndPatientDiscountExplained:
      "https://support.fullscript.com/hc/en-us/articles/360052933571-Dispensary-individual-patient-discounts",
    legacyDiscountExplained:
      "https://support.fullscript.com/hc/en-us/articles/360052933571-Dispensary-individual-patient-discounts",
    growingYourPracticeRevenue:
      "https://support.fullscript.com/hc/en-us/articles/16464646408859-Growing-your-practice-revenue",
    autoshipDiscountSettingsExplained:
      "https://support.fullscript.com/hc/en-us/articles/16413986025883-Autoship-save-discount",
    autoshipTermsConditionsExplained: "https://fullscript.com/autoship-terms",
    autoshipDiscountExplained:
      "https://support.fullscript.com/hc/en-us/articles/16413986025883-Autoship-save-discount#h_01H32WBESQY7Y3HABD27X3FHA8",
    patients: "https://fullscript.com/patients",
    supplementQuality: "https://fullscript.com/blog/fullscript-quality-assurance",
    termsOfServicePatients: "https://fullscript.com/terms-of-service#terms2",
    trackingDelilvery:
      "https://support.fullscript.com/hc/en-us/sections/4418456421275-Tracking-delivery",
    howToVideo: "https://support.fullscript.com/hc/en-us/sections/7118941513627-Patient-videos",
    returnsAndReplacements: "https://support.fullscript.com/hc/en-us/sections/360003111932-Returns",
    autoshipProgram: "https://support.fullscript.com/hc/en-us/sections/5464132592155-Autoship",
    evidenceBasedDecisionSupport: "https://fullscript.com/blog/evidence-based-decision-support",
    emersonTerms: {
      termsOfService: "https://emersonecologics.com/terms-of-sale",
      privacyPolicy: "https://emersonecologics.com/privacy-policy",
    },
    studentOrdering: "https://fullscript.com/for/student-ordering#video",
    demo: "https://fullscript.com/demo",
    stripeConnectedAccountAgreement: "https://stripe.com/legal/connect-account",
    dispensarySalesTaxUS:
      "https://support.fullscript.com/hc/en-us/articles/13283882528923-US-dispensaries-Sales-tax",
    dispensarySalesTaxCA:
      "https://support.fullscript.com/hc/en-us/articles/13279981759771-Canadian-dispensaries-Sales-tax",
    prop65Warnings: "http://www.p65warnings.ca.gov",
    emerson: {
      support: "https://help.emersonecologics.com/hc/en-us",
    },
    labsToolkit: "https://fullscript.com/labs",
  },
} as const;

export { sharedRoutes };
